import { signalStore, withState, withMethods, patchState, withComputed, withProps } from '@ngrx/signals';
import { computed, inject, resource } from '@angular/core';
import { PendingRequestService } from './pending-request.service';
import { LossRunReviewViewModel, SubmissionReviewViewModel } from '@program-suite/data-common/program';

export const PendingRequestStore = signalStore(
  { providedIn: 'root' },
  withState<{ filterValues: object; submissionReview?: SubmissionReviewViewModel | null, lossRunReview?: LossRunReviewViewModel | null }>({
    filterValues: <object>{},
    submissionReview: <SubmissionReviewViewModel | null>null,
    lossRunReview: <LossRunReviewViewModel | null>null,
  }),
  withComputed((state) => ({
    debug: computed(() => ({
      filterValues: state?.filterValues?.(),
      submissionReview: state?.submissionReview?.(),
    })),
  })),
  withMethods((store, pendingRequestService = inject(PendingRequestService)) => ({
    setFilterValues(value: object) {
      patchState(store, {
        filterValues: value,
      });
    },
    setSubmissionReview(submissionReview: SubmissionReviewViewModel | null) {
      patchState(store, {
        submissionReview: submissionReview,
      });
    },
    async getSubmissionReview(submissionGuid: string) {
      const submissionReview = await pendingRequestService.getSubmissionReview(submissionGuid);
      this.setSubmissionReview(submissionReview);
    },
    issueLossRunRequest(formData: FormData) {
      return pendingRequestService.issueLossRunRequest(formData);
    },
    setLossRunReview(lossRunReview: LossRunReviewViewModel | null) {
      patchState(store, {
        lossRunReview: lossRunReview,
      });
    },
    async getLossRunReview(lossRunRequestGuid: string) {
      const lossRunReview = await pendingRequestService.getLossRunReview(lossRunRequestGuid);
      this.setLossRunReview(lossRunReview);
    },
    async updatePendingRequestStatus(req: any) {
      await pendingRequestService.updatePendingRequestStatus(req);
    }
  })),
  withProps((store, pendingRequestService = inject(PendingRequestService)) => ({
    resource: resource({
      request: store.filterValues,
      loader: async (request) => {
        const filter = request.request;
        const pendingRequests = await pendingRequestService.getPendingRequests(filter);
        return pendingRequests;
      },
    }),
  }))
);